import { render, staticRenderFns } from "./ModalUploadPatient.vue?vue&type=template&id=5fee04d0&scoped=true"
import script from "./ModalUploadPatient.vue?vue&type=script&lang=js"
export * from "./ModalUploadPatient.vue?vue&type=script&lang=js"
import style0 from "./ModalUploadPatient.vue?vue&type=style&index=0&id=5fee04d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fee04d0",
  null
  
)

export default component.exports